(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payfooter/assets/javascripts/text/sum.js') >= 0) return;  svs.modules.push('/components/tur/payfooter/assets/javascripts/text/sum.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.payfooter = svs.tur.payfooter || {};
svs.tur.payfooter.text = svs.tur.payfooter.text || {};
class Sum extends svs.tur.payfooter.text.Default {
  constructor(_ref) {
    let _ref$text = _ref.text,
      text = _ref$text === void 0 ? 'Summa' : _ref$text,
      _ref$amount = _ref.amount,
      amount = _ref$amount === void 0 ? 0 : _ref$amount;
    super({
      text,
      listenOn: svs.tur.payfooter.SUM_UPDATED,
      amount
    });
    this.log = new svs.core.log.Logger('betslip:payfooter:text:sum');
    this.amountHandler.dimmed = true;
  }
  classNames() {
    return ['payfooter-text-sum'];
  }
}
svs.tur.payfooter.text.Sum = Sum;

 })(window);